export const generatedContentFormat = ['text/plain', 'text/markdown'];
